/* eslint-disable import/prefer-default-export */
import { UseQueryOptions, useQuery } from "@tanstack/react-query";
import { getContactBook } from "api/services/user";
import useDebounce from "hooks/useDebounce";
import { userQueryKeys } from "./userQueryKeys";

type UseSearchContactsParams = {
  query?: string;
  pageSize?: number;
  page?: number;
};

export const useSearchContacts = (params: UseSearchContactsParams = {}, options?: UseQueryOptions) => {
  const { query = "", pageSize = 10, page = 1 } = params;

  // Debounce the search query to avoid excessive API calls
  const debouncedQuery = useDebounce(query, 300);

  return useQuery<any>({
    queryKey: userQueryKeys.userSearchContacts({ query: debouncedQuery, pageSize, page }),
    queryFn: () => searchContactsFn({ query: debouncedQuery, pageSize, page }),
    staleTime: 2 * 60 * 1000, // 2 minutes
    ...options,
  });
};

function searchContactsFn(params: UseSearchContactsParams) {
  const { query = "", pageSize = 10, page = 1 } = params;

  const config = {
    params: {
      page_size: pageSize,
      page,
      ...(query.trim() && { query: query.trim() }),
    },
  };

  return getContactBook(config).then((res) => {
    const data = res?.data;
    return data?.results || data || [];
  });
}
